import React from "react";
import "./hippo-offer.css";
import { ReactComponent as HippoOfferIcon } from "../../../assets/hippo-offer.svg";

const HippoOffer = ({ hippoOfferRate }) => {
  return (
    <div className="hippo-offer-wrapper">
      <span className="hippo-offer-rate">
        Hippo offer&nbsp; {hippoOfferRate}%
      </span>
      <HippoOfferIcon />
    </div>
  );
};

export default HippoOffer;
